export default [
    {
        path: '/estadisticas',
        name: 'estadisticas',
        component: () => import(/* webpackChunkName: "configurar" */ '../../pages/estadisticas').then(m => m.default || m),
    },
]